import http from '../../axios-config/g-http-metodos';

function getRepresentanteByCliente(clienteId) {
  const { res, erro, requisicao } = http.get(`Representante/GetRepresentanteByCliente/${clienteId}`)
  return { RepresentanteArray: res, erro, requisicao }
}

function getRepresentante() {
  const { res, erro, requisicao } = http.get(`Representante/get`)
  return { RepresentanteArray: res, erro, requisicao }
}

function getUsuarioRepresentante(UsuarioRepresentanteViewModel) {
  const { res, erro, requisicao } = http.postArray("Representante/getUsuarioRepresentante", UsuarioRepresentanteViewModel)
  return { RepresentanteArray: res, erro, requisicao }
}

function excluirUsuarioRepresentante(UsuarioRepresentanteViewModel) {
  const { res, erro, requisicao } = http.postArray("Representante/ExcluirUsuarioRepresentante", UsuarioRepresentanteViewModel)
  return { RepresentanteArray: res, erro, requisicao }
}

function postUsuarioRepresentante(UsuarioRepresentanteViewModel) {
  const { res, erro, requisicao } = http.postArray("Representante/PostUsuarioRepresentante", UsuarioRepresentanteViewModel)
  return { RepresentanteArray: res, erro, requisicao }
}

function getRepresentanteByPesquisa(pesquisaEscrita, empresaId){
  const { res, erro, requisicao } = http.get(`Representante/GetRepresantanteByPesquisaEEmpresaId/${pesquisaEscrita}/${empresaId}`)
  return { RepresentanteArray: res, erro, requisicao }
}

function getRepresentanteByPesquisaEUsuario(pesquisaEscrita){
  const { res, erro, requisicao } = http.get(`Representante/GetRepresentanteByUsuarioLogadoEPesquisa/${pesquisaEscrita}`)
  return { RepresentanteArray: res, erro, requisicao }
}


function GetRepresentanteByUsuarioLogado(){
  const { res, erro, requisicao } = http.get(`Representante/GetRepresentanteByUsuarioLogado`);
  return { res, erro, requisicao };
}

function getRepresentanteByNome(FiltroNome){
  if(!FiltroNome) return { RepresentanteArray: [], erro: {}, requisicao:{} }
  const { res, erro, requisicao } = http.get(`Representante/Get/${FiltroNome}`)
  return { RepresentanteArray: res, erro, requisicao }
}

function enviarRepresentanteCRM(){
  const { res, erro, requisicao } = http.post(`Representante/EnviarRepresentanteCRM`)
  return { RepresentanteArray: res, erro, requisicao }
}

const RepresentanteController = {
  excluirUsuarioRepresentante,
  postUsuarioRepresentante,
  getUsuarioRepresentante,
  getRepresentanteByCliente,
  getRepresentante,
  getRepresentanteByPesquisa,
  getRepresentanteByNome,
  GetRepresentanteByUsuarioLogado,
  getRepresentanteByPesquisaEUsuario,
  enviarRepresentanteCRM
}

export default RepresentanteController
